// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"S6-z","inlineTitle":"T6-z","sponsoredAdsWrapper":"U6-z","marketplaceRecosWrapper":"V6-z","brandShopTheLookWrapper":"W6-z"};